module.exports = __webpack_public_path__ + "static/img/ios_it.8eb762d2.png";